/* istanbul ignore file */
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

export const root = css`
  position: absolute;
  right: var(${spacing.sm});
  bottom: var(${spacing.sm});
  background-color: var(${colors.surface.default});
  box-shadow: 0 0 4px 0 rgba(14, 14, 17, 0.1);

  &:hover {
    background-color: var(${colors.surface.default}) !important;
  }
`;

export const icon = css`
  flex-shrink: 0;
`;
